export default {
  nav: {
    home: 'Дома',
    products: 'Сите производи',
    categories: 'Категории',
    about: 'За нас',
    contact: 'Контакт',
    trackService: 'Следи Сервис',
    trackOrder: 'Следи Нарачка',
    login: 'Најави се',
  },
  titles: {
    home: 'Дома',
    products: 'Сите производи',
    productDetail: 'Детали за производ',
    category: 'Категорија',
    cart: 'Кошничка',
    checkout: 'Плаќање',
    search: 'Пребарување',
    wishlist: 'Листа на желби',
    about: 'За нас',
    contact: 'Контакт',
    login: 'Најава',
    register: 'Регистрација',
    privacy: 'Политика за приватност',
    terms: 'Услови за користење',
    returns: 'Политика за враќање',
    delivery: 'Информации за достава',
    account: 'Моја сметка',
    orderSuccess: 'Нарачката е потврдена',
    trackService: 'Следи сервис',
    bookService: 'Закажи сервис',
    forgotPassword: 'Ресетирај лозинка',
    signingIn: 'Најавување...',
  },
  header: {
    searchPlaceholder: 'Пребарај производи...',
    searchPlaceholderMobile: 'Пребарај...',
    profile: 'Профил',
    login: 'Најави се',
    account: 'Профил',
    register: 'Регистрирај се',
    wishlist: 'Омилени',
    cart: 'Кошничка',
    freeShipping: '🚚 Бесплатна достава над {threshold} {currency}',
  },
  footer: {
    description: 'Вашата дестинација за електроника, делови и професионален сервис. Квалитетни производи по достапни цени.',
    quickLinks: 'Брзи линкови',
    allProducts: 'Сите производи',
    help: 'Помош',
    delivery: 'Достава',
    returns: 'Враќање на производи',
    terms: 'Услови за користење',
    privacy: 'Политика за приватност',
    contact: 'Контакт',
    contactInfo: 'Контакт',
    workingHours: 'Пон-Саб: 09:00 - 20:00',
    paymentMethods: 'Начини на плаќање:',
    securePayment: '🔒 Сигурно плаќање',
    fastDelivery: '🚚 Брза достава',
    returnPolicy: '↩️ 14 дена враќање',
    allRightsReserved: 'Сите права задржани.',
    termsShort: 'Услови',
    privacyShort: 'Приватност',
    returnsShort: 'Враќање',
    deliveryShort: 'Достава',
  },
  home: {
    heroTitle: 'Најдобрата електроника на едно место',
    heroSubtitle: 'Квалитетни производи, делови за поправка и професионален сервис. Достава низ цела Македонија.',
    shopNow: 'Купи сега',
    featuredProducts: 'Препорачани производи',
    categories: 'Категории',
    whyChooseUs: 'Зошто да не изберете?',
    quality: 'Квалитет',
    qualityDesc: 'Само проверени производи од доверливи добавувачи',
    fastDelivery: 'Брза достава',
    fastDeliveryDesc: 'Достава низ цела Македонија за 24-48 часа',
    support: 'Поддршка',
    supportDesc: 'Професионален тим на располагање 24/7',
    warranty: 'Гаранција',
    warrantyDesc: 'Гаранција на сите производи и услуги',
    freeShipping: 'Бесплатна достава',
    freeShippingOver: 'над {threshold} {currency}',
    securePayment: 'Сигурно плаќање',
    sslProtection: 'SSL заштита',
    returnPolicy: '14 дена враќање',
    noQuestions: 'без прашања',
    support247: 'Поддршка 24/7',
    hereForYou: 'тука сме за вас',
    products: 'производи',
    needService: 'Потребен ви е сервис?',
    serviceDescription: 'Донесете го вашиот уред за бесплатна дијагноза. Професионална поправка со гаранција.',
    bookService: 'Закажи сервис',
  },
  service: {
    title: 'Закажи сервис',
    subtitle: 'Изберете ја услугата што ви е потребна и ние ќе ве контактираме што е можно поскоро.',
    selectService: 'Избери услуга',
    repair: 'Сервис за поправка',
    review: 'Рецензија на производ',
    sell: 'Продади го твојот производ',
    showcase: 'Презентација на производ',
    fullName: 'Име и презиме',
    phoneNumber: 'Телефонски број',
    emailAddress: 'Е-пошта',
    description: 'Опис / Детали',
    descriptionPlaceholder: 'Опишете го проблемот со вашиот уред...',
    tellUsMore: 'Кажете ни повеќе...',
    submitRequest: 'Испрати барање',
    sendingRequest: 'Се испраќа...',
  },
  category: {
    notFound: 'Категоријата не е пронајдена',
    productsCount: 'производи',
    empty: 'Нема производи во оваа категорија',
  },
  products: {
    title: 'Сите производи',
    items: 'производи',
    noProducts: 'Нема достапни производи',
    noProductsFound: 'Не се пронајдени производи',
    loading: 'Вчитување...',
    addToCart: 'Додади во кошничка',
    inStock: 'На залиха',
    outOfStock: 'Нема на залиха',
    price: 'Цена',
    minPrice: 'Мин',
    maxPrice: 'Макс',
    viewDetails: 'Погледни детали',
    viewAll: 'Види ги сите',
    search: 'Пребарај',
    searchPlaceholder: 'Пребарај производи...',
    categories: 'Категории',
    allCategories: 'Сите категории',
    sortBy: 'Сортирај',
    sortByName: 'По име',
    sortByPrice: 'По цена',
    sortByDate: 'По дата',
    sortAscending: 'Растечки',
    sortDescending: 'Опаѓачки',
    previous: 'Претходно',
    next: 'Следно',
    page: 'Страна {current} од {total}',
  },
  product: {
    addToCart: 'Додади во кошничка',
    added: 'Додадено',
    reviews: 'Рецензии',
    reviewsComingSoon: 'Рецензии наскоро',
    reviewsDesc: 'Функцијата за рецензии од купувачи наскоро ќе биде достапна во нашата продавница.',
    inStock: 'На залиха',
    outOfStock: 'Нема на залиха',
    quantity: 'Количина',
    description: 'Опис',
    specifications: 'Спецификации',
    relatedProducts: 'Слични производи',
    stock: 'Залиха',
    showStock: 'Прикажи залиха',
    hideStock: 'Сокриј залиха',
    sku: 'SKU',
    barcode: 'Баркод',
    includesTax: 'вклучува ДДВ',
    priceWithoutTax: 'Цена без ДДВ',
    pieces: 'парчиња',
    fastDelivery: 'Брза достава',
    deliveryDays: '1-3 дена',
    warranty: 'Гаранција',
    warrantyMonths: '12 месеци',
    returns: 'Враќање',
    returnDays: '14 дена',
    freeShipping: 'Бесплатна достава!',
    shipping: 'Достава',
    qualifiesForFreeShipping: 'Вашата нарачка квалификува за бесплатна достава',
    addMoreForFreeShipping: 'Додадете уште {amount} за бесплатна достава',
    total: 'Вкупно',
    acceptedPaymentMethods: 'Прифатени начини на плаќање',
    cash: 'Готовина',
    card: 'Картичка',
    bankTransfer: 'Трансфер',
    mobilePayment: 'Мобилно плаќање',
    noDescription: 'Нема опис за овој производ.',
    unit: 'Единица',
    piece: 'Парче',
    category: 'Категорија',
    locations: 'Локации',
    addedToCart: 'Производот е додаден во кошничката!',
    vat: 'ДДВ',
  },
  cart: {
    title: 'Кошничка',
    empty: 'Вашата кошничка е празна',
    continueShopping: 'Продолжи со купување',
    subtotal: 'Меѓувкупно',
    tax: 'Данок',
    total: 'Вкупно',
    checkout: 'Плати',
    remove: 'Отстрани',
    emptyCart: 'Испразни кошничка',
    shipping: 'Достава',
    free: 'Бесплатно',
    freeShippingMessage: 'Додадете уште {amount} за бесплатна достава',
    proceedToCheckout: 'Продолжи кон наплата',
    summary: 'Резиме на нарачка',
  },
  checkout: {
    title: 'Плаќање',
    shippingInfo: 'Информации за достава',
    paymentMethod: 'Начин на плаќање',
    orderSummary: 'Резиме на нарачка',
    placeOrder: 'Потврди нарачка',
    name: 'Име и презиме',
    email: 'Email',
    phone: 'Телефон',
    address: 'Адреса',
    city: 'Град',
    postalCode: 'Поштенски број',
    notes: 'Белешки (опционално)',
    cash: 'Готовина',
    card: 'Картичка',
    bankTransfer: 'Банкарски трансфер',
    mobilePayment: 'Мобилно плаќање',
    thankYou: 'Ви благодариме за вашата нарачка!',
    orderConfirmed: 'Вашата нарачка #{orderNumber} е потврдена.',
    confirmationEmail: 'Ви испративме е-пошта за потврда со сите детали.',
    guestCheckout: 'Нарачка како гостин',
    guestCheckoutDesc: 'Можете да нарачате без да креирате профил. Ќе ви испратиме потврда на е-пошта.',
  },
  about: {
    title: 'За нас',
    defaultDescription: 'Добредојдовте во {storeName}!',
    defaultContent: 'Ние сме посветени на обезбедување на најдобри производи и услуги за нашите клиенти.',
    contactInfo: 'Контакт информации',
    name: 'Име',
    email: 'Email',
    phone: 'Телефон',
    address: 'Адреса',
    followUs: 'Следете не',
    subtitle: 'Вашиот доверлив партнер за електроника и технолошки решенија.',
    socialDescription: 'Следете ги најновите понуди и новости на нашите социјални мрежи.',
    qualityTitle: 'Гарантиран Квалитет',
    qualityDesc: 'Ние гарантираме 100% оригинални производи директно од сертифицирани производители.',
    deliveryTitle: 'Брза Испорака',
    deliveryDesc: 'Сигурни партнери за испорака кои гарантираат дека вашите нарачки ќе стигнат навреме.',
    secureTitle: 'Безбедно Плаќање',
    secureDesc: 'Вашите трансакции се заштитени со највисоки индустриски безбедносни стандарди.',
  },
  contact: {
    title: 'Контакт',
    getInTouch: 'Стапите во контакт',
    sendMessage: 'Испрати порака',
    name: 'Име',
    email: 'Email',
    subject: 'Наслов',
    message: 'Порака',
    send: 'Испрати порака',
    phone: 'Телефон',
    address: 'Адреса',
    subtitle: 'Тука сме да помогнеме и да одговориме на сите ваши прашања.',
    success: 'Вашата порака е испратена успешно! Ќе ве контактираме наскоро.',
    sending: 'Праќање...',
  },
  search: {
    title: 'Резултати од пребарување',
    query: 'Пребарување за: "{query}"',
    noResults: 'Нема резултати за "{query}"',
    tryAgain: 'Обидете се со друг термин',
    enterTerm: 'Внесете термин за пребарување',
  },
  register: {
    title: 'Регистрирај се',
    firstName: 'Име',
    lastName: 'Презиме',
    email: 'Email',
    phone: 'Телефон',
    phonePlaceholder: '+389 7X XXX XXX',
    password: 'Лозинка',
    confirmPassword: 'Потврди лозинка',
    passwordsDoNotMatch: 'Лозинките не се совпаѓаат',
    marketingConsent: 'Сакам да примам маркетиншки пораки',
    submit: 'Регистрирај се',
    registering: 'Регистрирање...',
    success: 'Успешно се регистриравте!',
    error: 'Грешка при регистрација',
    alreadyHaveAccount: 'Веќе имате сметка?',
    backToHome: 'Врати се дома',
  },
  login: {
    title: 'Најави се',
    email: 'Email',
    password: 'Лозинка',
    submit: 'Најави се',
    loggingIn: 'Најавување...',
    error: 'Грешка при најава',
    noAccount: 'Немате сметка?',
    registerHere: 'Регистрирајте се тука',
    successMessage: 'Успешно се најавивте.',
    rememberMe: 'Запомни ме',
    forgotPassword: 'Ја заборавивте лозинката?',
    orContinueWith: 'Или продолжете со',
    signInWithGoogle: 'Најави се со Google',
    signInWithFacebook: 'Најави се со Facebook',
  },
  account: {
    title: 'Моја Сметка',
    welcome: 'Добредојдовте, {name}',
    completeProfileMessage: 'Ве молиме додадете го вашиот телефонски број за да го комплетирате профилот.',
    details: 'Детали за сметката',
    logout: 'Одјава',
    orders: 'Историја на нарачки',
    noOrders: 'Немате нарачки сеуште.',
    orderNumber: 'Број на нарачка',
    date: 'Дата',
    total: 'Вкупно',
    cancelOrder: 'Откажи нарачка',
    confirmCancel: 'Дали сте сигурни дека сакате да ја откажете оваа нарачка?',
    orderCancelled: 'Нарачката е успешно откажана',
    profile: 'Профил',
    addresses: 'Адреси',
    security: 'Безбедност',

    // Address form
    addressName: 'Име на адреса (пр. Дома)',
    streetAddress: 'Улица',
    city: 'Град',
    postalCode: 'Поштенски број',
    country: 'Држава',
    defaultShippingAddress: 'Стандардна адреса за достава',
    setAsDefault: 'Постави како стандардна адреса за достава',
    editAddress: 'Уреди адреса',
    newAddress: 'Нова адреса',
    addAddress: 'Додади нова',
    addressUpdated: 'Адресата е ажурирана',
    addressCreated: 'Адресата е креирана',
    addressDeleted: 'Адресата е избришана',
    deleteAddressConfirm: 'Дали сте сигурни дека сакате да ја избришете оваа адреса?',
    saveChanges: 'Зачувај промени',
    notificationPreferences: 'Нагодувања за известувања',
    emailNotifications: 'Email известувања',
    smsNotifications: 'SMS известувања',
    whatsappNotifications: 'WhatsApp известувања',
    profileUpdated: 'Профилот е успешно ажуриран',
    passwordChanged: 'Лозинката е успешно променета',
    currentPassword: 'Тековна лозинка',
    newPassword: 'Нова лозинка',
    changePassword: 'Промени лозинка',
  },
  forgotPassword: {
    title: 'Ресетирај лозинка',
    subtitle: "Внесете ја вашата е-пошта и ќе ви испратиме линк за ресетирање на лозинката.",
    email: 'Е-пошта',
    submit: 'Испрати линк',
    sending: 'Се испраќа...',
    backToLogin: 'Назад кон најава',
    success: 'Линкот е испратен! Проверете ја вашата е-пошта.',
    error: 'Неуспешно испраќање. Обидете се повторно.',
  },
  common: {
    loading: 'Вчитување...',
    error: 'Грешка',
    tryAgain: 'Обидете се повторно',
    back: 'Назад',
    close: 'Затвори',
    save: 'Зачувај',
    cancel: 'Откажи',
    delete: 'Избриши',
    edit: 'Уреди',
    view: 'Погледни',
    yes: 'Да',
    no: 'Не',
    currency: 'ден',
    language: 'Јазик',
    continueShopping: 'Продолжи со купување',
    track: 'Следи',
    select: 'Избери',
    previous: 'Претходно',
    next: 'Следно',
    fillRequiredFields: 'Ве молиме пополнете ги сите задолжителни полиња',
    required: 'Задолжително',
    invalidEmail: 'Неважечки е-маил',
    invalidPhone: 'Неважечки телефонски број',
    pageOf: 'Страна {current} од {total}',
    processing: 'Обработка...',
    noData: 'Нема достапни податоци',
  },
  track: {
    title: 'Следете го вашиот сервис',
    subtitle: 'Внесете го бројот на сервисниот налог или бројот за следење за да го проверите статусот.',
    placeholder: 'пр. SRV-12345',
    notFound: 'Сервисниот налог не е пронајден',
    details: 'Детали за сервисот',
    date: 'Датум',
    estimatedCompletion: 'Очекувано завршување',
  },
  wishlist: {
    title: 'Мои омилени',
    empty: 'Вашата листа на омилени е празна',
    emptyMessage: 'Зачувајте производи што ви се допаѓаат за да ги прегледате подоцна.',
    addToWishlist: 'Додај во омилени',
    removeFromWishlist: 'Отстрани од омилени',
    removed: 'Отстрането од омилени',
    added: 'Додадено во омилени',
  },
  serviceStatus: {
    received: 'Примен',
    diagnosing: 'Дијагностика',
    waiting_approval: 'Чека одобрение',
    approved: 'Одобрен',
    in_progress: 'Во работа',
    waiting_parts: 'Чека делови',
    ready: 'Готов',
    delivered: 'Подигнат',
    cancelled: 'Откажан',
  },
  policies: {
    common: {
      lastUpdated: 'Последна ажурирање: {date}',
      contact: {
        title: 'Контакт',
        text: 'За прашања, ве молиме контактирајте не:',
        hours: 'Работно време: Понеделник - Петок: 09:00 - 18:00, Сабота: 09:00 - 14:00'
      }
    },
    delivery: {
      title: 'Политика за достава',
      intro: 'Испорачуваме нарачки низ целата територија на Република Северна Македонија. Работиме со доверливи курирски компании за обезбедување на безбедна и навремена достава.',
      areas: {
        title: '1. Области на достава',
        skopje: { title: 'Скопје и околина', text: 'Стандардна достава: 1-2 работни дена' },
        other: { title: 'Други градови', text: 'Стандардна достава: 2-4 работни дена' },
        remote: { title: 'Оддалечени области', text: 'Стандардна достава: 3-5 работни дена' },
        express: { title: 'Експрес достава', text: 'Достапна за избрани области: 24 часа' }
      },
      time: {
        title: '2. Време на обработка и достава',
        processingTitle: 'Обработка на нарачка',
        processingList: [
          'Нарачките се обработуваат во рок од 1-2 работни дена',
          'Нарачки примени пред 14:00 се обработуваат истиот ден',
          'Нарачки примени по 14:00 се обработуваат следниот работен ден',
          'За време на празници и викенди, обработката може да се одложи'
        ],
        deliveryTitle: 'Време на достава',
        deliveryList: [
          'Времето на достава се пресметува од моментот на испраќање',
          'Работни дена се од понеделник до петок (освен државни празници)',
          'Ќе добиете SMS или email со информации за пратката',
          'Можете да ја следите вашата пратка со бројот за следење'
        ]
      },
      costs: {
        title: '3. Трошоци за достава',
        freeTitle: 'Бесплатна достава',
        freeText: 'Бесплатна достава е достапна за нарачки над {amount} денари.',
        standardTitle: 'Стандардна достава',
        standardList: [
          'Скопје и околина: 150 - 250 денари',
          'Други градови: 200 - 350 денари',
          'Оддалечени области: 300 - 500 денари',
          'Точните трошоци се прикажани при нарачување'
        ],
        expressTitle: 'Експрес достава',
        expressText: 'Експрес достава (24 часа) е достапна за избрани области. Трошоците се прикажани при нарачување.'
      },
      methods: {
        title: '4. Начини на достава',
        home: { title: 'Достава до адреса', text: 'Курирот ќе го донесе производот на вашата адреса. Ве молиме обезбедете точност на адресата и присуство при достава.' },
        box: { title: 'Достава до поштенски сандаче', text: 'Можете да изберете достава до поштенски сандаче на избрана локација. Ќе добиете известување кога пратката е подготвена.' },
        store: { title: 'Подигнување од продавница', text: 'Можете да го подигнете производот од нашата продавница. Ќе ве известиме кога нарачката е подготвена.' },
        work: { title: 'Достава до работно место', text: 'Можете да нарачате достава до вашето работно место. Ве молиме обезбедете точна адреса и контакт информации.' }
      },
      delays: {
        title: '7. Задоцнувања и проблеми',
        text1: 'Додека се трудиме да ги почитуваме наведените рокови, може да дојде до задоцнувања поради непредвидливи околности (лошо време, сообраќајни проблеми, итн.).',
        text2: 'Ако вашата пратка задоцни повеќе од 2 работни дена од наведениот рок, ве молиме контактирајте не за да провериме статусот.'
      }
    },
    return: {
      title: 'Политика за враќање',
      intro: 'Согласно со Законот за заштита на потрошувачите на Република Северна Македонија, имате право да го откажете нарачаниот производ во рок од 14 календарски дена од датумот на примање, без да наведете причина.',
      introTitle: 'Вашето право на враќање',
      deadline: {
        title: '1. Рок за враќање',
        text1: 'Рокот од 14 дена започнува од денот на примање на производот од ваша страна или од трето лице (освен превозник) назначено од вас.',
        text2: 'За да го искористите правото на враќање, мора да нè известите за вашата одлука преку јасна изјава (на пример, писмо по пошта, факс или електронска пошта) пред истекот на рокот од 14 дена.'
      },
      conditions: {
        title: '2. Услови за враќање',
        mustBeTitle: 'Производот мора да биде:',
        mustBeList: [
          'Во оригинална состојба, неупотребуван',
          'Со оригинална амбалажа и етикети',
          'Со сите прилози и документи (ако ги има)',
          'Без оштетувања или траги од употреба'
        ],
        cannotBeTitle: 'Производи кои не можат да се вратат:',
        cannotBeList: [
          'Персонализирани производи направени според ваши спецификации',
          'Производи кои брзо се расипуваат или имаат краток рок на траење',
          'Запечатени производи отворени по достава (CD, DVD, софтвер)',
          'Производи кои не се соодветни за враќање од здравствена или хигиенска причина'
        ]
      },
      process: {
        title: '3. Процес на враќање',
        step1: { title: 'Чекор 1', subtitle: 'Контактирајте не' },
        step2: { title: 'Чекор 2', subtitle: 'Подгответе го производот', text: 'Ставете го производот во оригинална амбалажа со сите прилози и документи.' },
        step3: { title: 'Чекор 3', subtitle: 'Испратете го производот', text: 'Испратете го на нашата адреса.' }
      },
      costs: {
        title: '4. Трошоци за враќање',
        text1: 'Ако производот е неисправен или не одговара на описот: Ние ги покриваме сите трошоци за враќање.',
        text2: 'Ако го враќате производот без причина (во рамките на законското право): Трошоците за враќање се на ваша сметка.'
      },
      refund: {
        title: '5. Враќање на средства',
        text1: 'Ќе го вратиме износот што го плативте за производот (вклучувајќи стандардни трошоци за достава) во рок од 14 календарски дена од примање на вратениот производ.',
        text2: 'Враќањето ќе се изврши на истиот начин на кој сте платиле.',
        note: 'Напомена: Може да задржиме износ за намалување на вредноста на производот ако тој е оштетен поради ваша вина.'
      },
      exchange: {
        title: '6. Размена на производ',
        text: 'Ако сакате да го замените производот со друг, ве молиме контактирајте не. Ќе се обидеме да го задоволиме вашето барање, под услов производот да биде достапен.'
      },
      warranty: {
        title: '7. Гаранција',
        text: 'Оваа политика за враќање не влијае на вашите законски права за гаранција. Ако производот има производна грешка, имате право на поправка, замена или враќање на средства согласно со гаранцијата на производителот.'
      }
    },
    privacy: {
      title: 'Политика за приватност',
      intro: '{storeName} се посветува на заштита на вашата приватност. Оваа политика објаснува како ги собираме, користиме, зачувуваме и штитиме вашите лични податоци кога користите нашиот веб-сајт и услуги.',
      introTitle: '1. Вовед',
      collection: {
        title: '2. Податоци кои ги собираме',
        givenTitle: '2.1. Податоци кои ни ги давате',
        givenList: ['Име и презиме', 'Електронска адреса (email)', 'Телефонски број', 'Адреса за достава', 'Информации за плаќање'],
        autoTitle: '2.2. Автоматски собрани податоци',
        autoList: ['IP адреса', 'Тип на прелистувач и верзија', 'Време на посета и прегледани страници', 'Cookies и слични технологии']
      },
      usage: {
        title: '3. Како ги користиме вашите податоци',
        list: [
          'За обработка и испорака на вашите нарачки',
          'За комуникација со вас во врска со вашите нарачки и прашања',
          'За подобрување на нашиот веб-сајт и услуги',
          'За испраќање на маркетиншки пораки (само со ваша согласност)',
          'За усогласување со законските обврски'
        ]
      },
      protection: {
        title: '4. Заштита на податоците',
        text: 'Ги користиме индустриски стандардни безбедносни мерки за заштита на вашите лични податоци, вклучувајќи шифрирање, безбедни сервери и ограничен пристап до податоците само за овластени лица.'
      },
      sharing: {
        title: '5. Споделување на податоци',
        text: 'Не ги продаваме вашите лични податоци на трети страни. Може да ги споделиме вашите податоци само со доставувачи на услуги (курирски компании, платни процесори) за извршување на нарачките, или кога тоа е законски задолжително.'
      },
      rights: {
        title: '6. Вашите права',
        text: 'Имате право на:',
        list: ['Пристап до вашите лични податоци', 'Корекција на неточни податоци', 'Бришење на вашите податоци', 'Ограничување на обработката', 'Преносливост на податоците', 'Приговор против обработка']
      },
      cookies: {
        title: '7. Cookies',
        text: 'Користиме cookies за подобрување на вашето искуство на нашиот веб-сајт. Може да ги контролирате cookies преку подесувањата на вашиот прелистувач.'
      },
      changes: {
        title: '8. Промени на политиката',
        text: 'Може да ја ажурираме оваа политика за приватност од време на време. Ќе ве известиме за какви било значајни промени преку нашиот веб-сајт или електронска пошта.'
      }
    },
    terms: {
      title: 'Услови за користење',
      lastUpdated: 'Последна ажурирање: {date}',
      section1: {
        title: '1. Прифаќање на условите',
        text: 'Со пристапување и користење на веб-сајтот на {storeName}, вие се согласувате да се придржувате кон овие услови за користење. Ако не се согласувате со овие услови, ве молиме не користете го нашиот веб-сајт.'
      },
      section2: {
        title: '2. Нарачки и плаќања',
        subsection1: {
          title: '2.1. Процес на нарачка',
          list: [
            'Сите нарачки се предмет на достапност на производите',
            'Нарачката се смета за прифатена кога ќе добиете потврда по електронска пошта',
            'Задржуваме право да одбиеме или откажеме нарачка од било која причина',
            'Цените се точни во моментот на нарачување, но може да се променат без претходна најава'
          ]
        },
        subsection2: {
          title: '2.2. Плаќање',
          list: [
            'Прифаќаме различни методи на плаќање (готовина при достава, картичка, банкарски трансфер)',
            'Плаќањето мора да се изврши пред или при достава',
            'Сите цени се изразени во денари (MKD) и вклучуваат ДДВ',
            'Задржуваме право да побараме дополнителна верификација за безбедност'
          ]
        }
      },
      section3: {
        title: '3. Цени и достапност',
        list: [
          'Сите цени се точни во моментот на објавување, но може да се променат',
          'Ако производот е недостижен по прифаќање на нарачката, ќе ве контактираме',
          'Задржуваме право да ги промениме цените без претходна најава',
          'Промотивните цени важат само за одреден период или додека трае залихата'
        ]
      },
      section4: {
        title: '4. Достава',
        text: 'Деталите за достава се достапни на страницата за достава. Обидете се да обезбедите точна адреса за достава. Не носиме одговорност за задоцнувања предизвикани од трети страни (курирски компании).',
        list: [
          'Времето на достава е приближно и може да варира',
          'Трошоците за достава се прикажани при нарачување',
          'Бесплатна достава е достапна за нарачки над одредена сума'
        ]
      },
      section5: {
        title: '5. Откажување и враќање',
        text: 'Согласно со законските права на потрошувачите, имате право да го откажете нарачаниот производ во рок од 14 дена од датумот на примање, без да наведете причина.',
        list: [
          'Производот мора да биде во оригинална состојба, неупотребуван и со оригинална амбалажа',
          'Трошоците за враќање се на ваша сметка, освен ако производот е неисправен',
          'Ќе го вратиме износот во рок од 14 дена од примање на вратениот производ',
          'Некои производи (персонализирани, свежи производи) не можат да се вратат'
        ]
      },
      section6: {
        title: '6. Интелектуална сопственост',
        text: 'Сите содржини на веб-сајтот, вклучувајќи текстови, слики, логоа и дизајн, се заштитени со авторски права и се сопственост на {storeName}. Забрането е неовластено копирање или употреба.'
      },
      section7: {
        title: '7. Одговорност',
        text: '{storeName} не носи одговорност за:',
        list: [
          'Штети предизвикани од употреба или неупотреба на нашите производи',
          'Задоцнувања во достава предизвикани од трети страни',
          'Технички проблеми или прекини на веб-сајтот',
          'Губење на податоци или финансиски загуби'
        ]
      },
      section8: {
        title: '8. Промени на условите',
        text: 'Задржуваме право да ги менуваме овие услови во секое време. Промените ќе бидат објавени на овој веб-сајт и ќе стапат на сила веднаш по објавувањето.'
      },
      section9: {
        title: '9. Применливо право',
        text: 'Овие услови се регулирани со законите на Република Северна Македонија. Сите спорови ќе се решаваат пред надлежните судови во Северна Македонија.'
      },
      section10: {
        title: '10. Контакт',
        address: 'Адреса',
        email: 'Email',
        phone: 'Телефон'
      }
    }
  },
  whatsapp: {
    chatWithUs: 'Разговарајте со нас',
    defaultMessage: 'Здраво! Имам прашање за вашите производи.'
  }
}
